// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jx-1";
export var messageSideRight = "_jx-2";
export var orderLookupBubbleContainer = "_jx-0";
export var submitButton = "_jx-3";